/**
 * redux-persist storage settings, in a dependency-free module.
 *
 * The store setup owns the persistor, but code that has to reach persisted
 * state directly (see `clearSessionMetadata`) cannot import the store without
 * creating an import cycle, so the key and the write throttle live here.
 */

export const PERSIST_KEY = 'bbk';

/**
 * How long redux-persist may batch storage writes. Any code that clears
 * persisted state and then navigates within this window must make the write
 * durable itself.
 */
export const PERSIST_THROTTLE_MS = 500;
